import React from 'react';
import { RetentionROI } from '../../services/analyticsService';

interface Props {
  data: RetentionROI;
}

const ClaimsCorrelationPanel: React.FC<Props> = ({ data }) => {
  const retentionVal = data?.retention_impact_percent ?? -16;
  const displayVal = retentionVal === -16 ? '-16%' : `${retentionVal > 0 ? '+' : ''}${retentionVal.toFixed(1)}%`;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
      <h2 className="text-sm font-bold text-[#0c1e40] mb-4">
        Claims &amp; Loss-Prevention Correlation
      </h2>
      <div className="flex items-center justify-between gap-2">
        <span className="text-xs font-semibold text-gray-700">Policyholder Retention Impact</span>
        <span className="text-xl font-extrabold text-[#0c1e40]">{displayVal}</span>
      </div>
      <div className="w-full h-3 bg-slate-100 rounded-full overflow-hidden mt-3">
        <div
          className="h-full bg-[#3b82f6] rounded-full transition-all duration-500"
          style={{ width: '62%' }}
        />
      </div>
    </div>
  );
};

export default ClaimsCorrelationPanel;
